import type { PropTypes } from './Info.types';
import type { ReactElement } from 'react';

import { Flex, Heading, Text } from '@rango-dev/whale';
import React from 'react';

export function Info(props: PropTypes): ReactElement {
  const { title, description } = props;

  return (
    <Flex direction="column" align="start" gap="1">
      <Heading size="5" weight="bold">
        {title}
      </Heading>
      <Text size="2" color="gray">
        {description}
      </Text>
    </Flex>
  );
}
